//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var focusableElementsSelector = ['input', 'select', 'button', 'textarea'].map(function (field) { return (field + ":not([disabled])"); }).concat( ['a[href]'],
  ['video[controls]'],
  ['audio[controls]'],
  ['[tabindex]:not([tabindex^="-"])'],
  ['[contenteditable]:not([contenteditable="false"])']
).join(',');

var ariaHiddenElements = [];

var script = {
  name: 'FocusLoop',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: true
    }
  },

  data: function data () {
    return {
      alreadyFocused: false
    }
  },

  computed: {
    getTabindex: function getTabindex () {
      return this.disabled ? -1 : 0
    }
  },

  watch: {
    isVisible: 'init',
    disabled: 'init'
  },

  mounted: function mounted () {
    this.init();
  },

  methods: {
    init: function init () {
      var this$1 = this;

      this.$nextTick(function () {
        var active = this$1.isVisible && !this$1.disabled;
        !this$1.disabled && this$1.focusFirst(active && this$1.autoFocus);
        this$1.managePrevFocusElement(active);
        this$1.lockForSwipeScreenReader(active);
        if (!active) {
          ariaHiddenElements = [];
        }
      });
    },

    managePrevFocusElement: function managePrevFocusElement (active) {
      if (!active && window.vflPrevFocusedElement) {
        return window.vflPrevFocusedElement.focus()
      }
      window.vflPrevFocusedElement = document.activeElement;
    },

    getElementsToAriaHidden: function getElementsToAriaHidden (focusLoopContainer) {
      function getElements (element) {
        var children = Array.from(element.children);
        children.forEach(function (el) {
          if (el === focusLoopContainer) { return }
          if (!el.contains(focusLoopContainer)) {
            ariaHiddenElements.push(el);
            return
          }
          getElements(el);
        });
      }
      getElements(document.body);
    },

    lockForSwipeScreenReader: function lockForSwipeScreenReader (active) {
      if ( active === void 0 ) active = true;

      if (active) { this.getElementsToAriaHidden(this.$refs.VuefocusLoopContainer); }
      ariaHiddenElements.forEach(function (el) {
        if (['SCRIPT', 'STYLE'].includes(el.nodeName) || el.hasAttribute('aria-live')) { return }
        el.setAttribute('aria-hidden', active.toString());
      });
    },

    focusFirst: function focusFirst (isAutoFocus) {
      if (isAutoFocus) {
        var elements = this.getFocusableElements();
        if (elements.length) { setTimeout(function () { return elements[0].focus(); }, 200); }
      }
    },

    getFocusableElements: function getFocusableElements () {
      var focusableElements = this.$refs.focusLoop.querySelectorAll(focusableElementsSelector);
      if (focusableElements && focusableElements.length) { return focusableElements }
      return []
    },

    handleFocusStart: function handleFocusStart () {
      var elements = this.getFocusableElements();
      if (elements.length) {
        var index = this.alreadyFocused ? elements.length - 1 : 0;
        this.alreadyFocused = true;
        elements[index].focus();
      }
    },

    handleFocusEnd: function handleFocusEnd () {
      var elements = this.getFocusableElements();
      elements.length && elements[0].focus();
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{ref:"VuefocusLoopContainer",staticClass:"vue-focus-loop"},[_c('div',{attrs:{"tabindex":_vm.getTabindex,"aria-hidden":"true"},on:{"focus":_vm.handleFocusStart}}),_vm._v(" "),_c('div',{ref:"focusLoop"},[_vm._t("default")],2),_vm._v(" "),_c('div',{attrs:{"tabindex":_vm.getTabindex,"aria-hidden":"true"},on:{"focus":_vm.handleFocusEnd}})]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

function install (Vue) {
  if (install.installed) { return }
  install.installed = true;
  Vue.component('FocusLoop', __vue_component__);
}

// auto install
if (typeof window !== 'undefined' && typeof window.Vue !== 'undefined') {
  window.Vue.use(install);
}

export default install;
export { __vue_component__ as FocusLoop };
